<template>
  <div class="cl-inner">
    考勤上传
    <div class="table-top">
      <!-- 选择学期 -->
      <div class="semester">
        <span class="required">*</span>
        <span class="text">选择学期</span>
        <a-select
          style="width: 286px"
          placeholder="请选择"
          @change="changeTerm"
        >
          <a-select-option
            v-for="item in termList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.termName }}
          </a-select-option>
        </a-select>
        <!-- <span class="tips">不支持已结束的学期</span> -->
      </div>
      <!-- 选择文件 -->
      <div class="file">
        <span class="required">*</span>
        <span class="text">选择文件</span>
        <!-- 导入班级 -->
        <div class="import-excel">
          <!-- 上传文件解析前显示 -->
          <div v-if="!fileLoding">
            <a-button class="import-btn">
              <img src="/icon/add.png" />
              <input
                type="file"
                @change="chooseFile"
                accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </a-button>
          </div>
          <!-- 上传文件解析后显示 -->
          <div v-if="fileLoding">
            <span class="file-name">{{ fileName }}</span>
            <a-button
              >重新导入
              <input
                type="file"
                @change="chooseFile"
                accept=".csv, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </a-button>
          </div>
        </div>
        <!-- 导入模板 -->
        <a
          class="template"
          href="https://static.khsdb.com/place/template/考勤上传模板1102.xlsx"
          download="考勤上传模板"
          @click="importTemplate()"
          >导入模板</a
        >
        <!-- <div class="tips">导入班级每次不超过200个</div> -->
      </div>
      <!-- 导入预览 -->
      <a-button
        :loading="loading"
        type="primary"
        class="preview"
        @click="preview()"
        >导入预览</a-button
      >
    </div>
    <!-- 表格部分 -->
    <div class="table" v-if="list.length > 0">
      <a-table
        :columns="columns"
        :data-source="list"
        bordered
        :pagination="false"
      >
        <!-- 序号 -->
        <span slot="ordinal" slot-scope="text, record">
          <span
            :class="{
              active: record.errMap && record.errMap.indexOf('0') != -1,
            }"
            >{{ text }}</span
          >
        </span>

        <!-- excel行号 -->
        <span slot="excelIndex" slot-scope="text, record">
          <span
            :class="{
              active: record.errMap && record.errMap.indexOf('0') != -1,
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 老师 -->
        <span slot="teacherName" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('3') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>

        <!-- 性别 -->
        <span slot="teacherGenderName" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('4') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 手机号 -->
        <span slot="mobile" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('5') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 学校 -->
        <span slot="schoolName" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('6') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 年级 -->
        <span slot="gradesText" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('7') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 班级类型 -->
        <span slot="classTypeText" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('8') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 上课日期 -->
        <span slot="textAttendDate" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('9') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 上课开始时间 -->
        <span slot="textAttendStartTime" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('10') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 上课结束时间 -->
        <span slot="textAttendEndTime" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('11') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 备注 -->
        <span slot="note" slot-scope="text, record">
          <span
            :class="{
              active:
                record.errMap &&
                (record.errMap.indexOf('12') != -1 ||
                  record.errMap.indexOf('0') != -1),
            }"
            >{{ text }}</span
          >
        </span>
        <!-- 状态 -->
        <span slot="status" slot-scope="text">
          <span :class="{ active: text == 2 }">{{
            text == 0 ? '待验证' : text == 1 ? '可导入' : '存在错误'
          }}</span>
        </span>
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <span v-if="record.status == 1">无</span>
          <a-popover v-else placement="left">
            <template slot="content">
              <p v-for="(item, index) in text" :key="index">{{ item }}</p>
            </template>
            <span class="error">查看错误</span>
          </a-popover>
        </span>
      </a-table>
      <div class="confirm-btn">
        <a-button type="primary" :disabled="confirmBtn" @click="confirm()"
          >确认导入</a-button
        >
      </div>
    </div>
    <!-- 查看错误框 -->
    <a-modal v-model="visibleErr" title="错误信息" width="358px" :footer="null">
      <p v-for="(item, index) in errorMsgList" :key="index">
        {{ index + 1 }}. {{ item }}
      </p>
      <div class="confirm-err">
        <a-button type="primary" @click="confirmErr()">我知道了</a-button>
      </div>
    </a-modal>
    <!-- 确认建班/重新导入框 -->
    <a-modal
      v-model="visibleWarn"
      width="358px"
      :closable="false"
      :footer="null"
    >
      <div class="warning-title">
        <img src="/icon/warning.png" />
        <span v-if="isConfirm">确认导入</span>
        <span v-else>确认重新导入预览</span>
      </div>
      <div class="warning-content" v-if="isConfirm">
        确认导入这{{ list.length }}条数据?
      </div>
      <div class="warning-content" v-else>未保存的数据将丢失，是否确认</div>
      <div class="confirm-warn">
        <a-button class="mr8" @click="cancelWarn()">取消</a-button>
        <a-button type="primary" v-if="isConfirm" @click="confirmWarn()"
          >确认</a-button
        >
        <a-button type="primary" v-else @click="importWarn()">确认</a-button>
      </div>
    </a-modal>
    <!-- 建班成功/建班失败框 -->
    <a-modal
      v-model="visibleTips"
      width="358px"
      :closable="false"
      :footer="null"
    >
      <!-- 建班失败 -->
      <div class="tips-title" v-if="errorClass">
        <img src="/icon/fail.png" />
        <div class="title">导入失败</div>
        <div>失败原因：{{ errText }}</div>
        <a-button type="primary" class="btn" @click="errorBtn">返回</a-button>
      </div>
      <!-- 建班成功 -->
      <div class="tips-title" v-if="successClass">
        <img src="/icon/success.png" />
        <div class="title">导入成功</div>
        <div>已成功导入{{ list.length }}条数据</div>
        <a-button type="primary" class="btn" @click="successBtn">确认</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import education from '../../api/education'
import teacher from '../../api/teacher'
const columns = [
  {
    title: '序号',
    dataIndex: 'ordinal',
    key: 'ordinal',
    align: 'center',
    scopedSlots: { customRender: 'ordinal' },
  },
  {
    title: 'excel行号',
    dataIndex: 'excelIndex',
    key: 'excelIndex',
    align: 'center',
    scopedSlots: { customRender: 'excelIndex' },
  },
  {
    title: '考勤老师',
    dataIndex: 'teacherName',
    key: 'teacherName',
    scopedSlots: { customRender: 'teacherName' },
    align: 'center',
  },
  {
    title: '性别',
    dataIndex: 'teacherGenderName',
    key: 'teacherGenderName',
    scopedSlots: { customRender: 'teacherGenderName' },
    align: 'center',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
    key: 'mobile',
    scopedSlots: { customRender: 'mobile' },
    align: 'center',
  },
  {
    title: '学校',
    dataIndex: 'schoolName',
    key: 'schoolName',
    scopedSlots: { customRender: 'schoolName' },
    align: 'center',
  },
  {
    title: '年级',
    dataIndex: 'gradesText',
    key: 'gradesText',
    scopedSlots: { customRender: 'gradesText' },
    align: 'center',
  },
  {
    title: '班级类型',
    dataIndex: 'classTypeText',
    key: 'classTypeText',
    scopedSlots: { customRender: 'classTypeText' },
    align: 'center',
  },
  {
    title: '上课日期',
    key: 'textAttendDate',
    dataIndex: 'textAttendDate',
    align: 'center',
    scopedSlots: { customRender: 'textAttendDate' },
  },
  {
    title: '上课开始时间',
    key: 'textAttendStartTime;',
    dataIndex: 'textAttendStartTime',
    align: 'center',
    scopedSlots: { customRender: 'textAttendStartTime' },
  },
  {
    title: '上课结束时间',
    key: 'textAttendEndTime',
    dataIndex: 'textAttendEndTime',
    align: 'center',
    scopedSlots: { customRender: 'textAttendEndTime' },
  },
  {
    title: '备注',
    key: 'note',
    dataIndex: 'note',
    align: 'center',
    scopedSlots: { customRender: 'note' },
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
  },
  {
    title: '操作',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center',
  },
]
export default {
  data() {
    return {
      columns,
      list: [],
      beforePreview: [], // 导入预览前的班级列表
      termList: [], // 学期列表
      termId: '', // 选择的学期id
      selectFile: '', // 选择的文件file
      fileLoding: false, // 文件是否解析完
      fileName: '', // 上传的文件名
      isConfirm: true, // 是否选择确认建班
      visibleErr: false, // 查看错误模态框
      visibleWarn: false, // 确认建班/重新导入模态框
      batchNumber: '', // 确认建班批次参数
      errorMsgList: [], // 错误信息列表
      checkConfirm: false, // 校验是否无错误信息
      visibleTips: false, // 创建成功/失败模态框
      successClass: false, // 创建成功
      errorClass: false, // 创建失败
      errText: '', // 创建失败原因
      importErr: '', // 选择文件失败原因
      confirmBtn: false, // 是否有错误，true-禁用确认建班 false-启用确认建班
      loading: false,
    }
  },
  created() {
    this.getTermList()
  },
  methods: {
    isRed(num1, num2, list) {
      if (list.errMap && list.errMap.length) {
        if (list.errMap.some((i) => i == num1)) {
          return true
        } else if (list.errMap.some((i) => i == num2)) {
          return true
        } else {
          return false
        }
      }
      this.$forceUpdate()

      console.log('errMap', num1, num2, list, list.errMap)
    },
    // 获取学期列表
    getTermList() {
      education.getClassTermList().then((res) => {
        this.termList = res.data
      })
    },
    // 选择学期
    changeTerm(value) {
      this.termId = value
      this.list = []
    },
    ///选择文件
    chooseFile(e) {
      this.list = []
      this.selectFile = e.target.files[0]
      this.fileName = e.target.files[0].name
      this.fileLoding = true
      e.target.value = ''
    },
    importTemplate() {
      console.log('importTemplate')
    },

    // 导入预览
    preview() {
      this.confirmBtn = false
      if (!this.termId) {
        this.$message.error('请选择学期')
        return
      }
      if (!this.selectFile) {
        this.$message.error('请选择文件')
        return
      }
      if (this.list.length !== 0) {
        this.isConfirm = false
        this.visibleWarn = true
        return
      }
      this.list = []
      this.loading = true
      // 上传文件
      teacher
        .chooseFileInfo({ fileName: this.selectFile, termId: this.termId })
        .then((res) => {
          this.importErr = ''
          this.list = res.data.map((item) => {
            return { ...item, errMap: [] }
          })
          this.beforePreview = res.data
          this.batchNumber = res.data[0].batchNumber
          // 导入预览
          // let a = []

          this.getInitFile(0)
          // console.log('length', this.list.length)

          // this.list.forEach((v, i) => {

          // })
        })
        .catch((err) => {
          console.log('err_upload', err.name)

          if (err.name == 'TypeError') {
            err.msg = '此文件已被修改，请重新上传。'
            this.$message.destroy()
          }
          this.errorMsgList = []
          this.errorMsgList.push(err.msg)
          this.visibleErr = true
        })
        .finally((res) => {
          console.log('111')
          this.loading = false
        })
    },
    getInitFile(i) {
      teacher.importPreview({ importId: this.list[i].id }).then((params) => {
        if (params.data.status == 2) {
          if (params.errList) {
            params.data.action = JSON.parse(params.errList)
            this.confirmBtn = true
            this.list[i].action = params.data.action
            params.data.errMap = []
            for (let key in eval('(' + params.errMap + ')')) {
              params.data.errMap.push(key)
            }
          }
        } else {
          params.data.errMap = []
        }
        this.list[i].attendDate = params.data.attendDate
        this.list[i].attendEndTime = params.data.attendEndTime
        this.list[i].attendStartTime = params.data.attendStartTime
        this.list[i].batchNumber = params.data.batchNumber
        this.list[i].classId = params.data.classId
        this.list[i].className = params.data.className
        this.list[i].courseId = params.data.courseId
        this.list[i].courseName = params.data.courseName
        this.list[i].gmtCreate = params.data.gmtCreate
        this.list[i].id = params.data.id
        this.list[i].mobile = params.data.mobile
        this.list[i].note = params.data.note
        this.list[i].operationLog = params.data.operationLog
        this.list[i].ordinal = params.data.ordinal
        this.list[i].schoolId = params.data.schoolId
        this.list[i].schoolName = params.data.schoolName
        this.list[i].status = params.data.status
        this.list[i].errMap = params.data.errMap
        this.list[i].teacherGender = params.data.teacherGender
        this.list[i].teacherGenderName = params.data.teacherGenderName
        this.list[i].teacherId = params.data.teacherId
        this.list[i].teacherName = params.data.teacherName
        this.list[i].termId = params.data.termId
        this.list[i].textAttendDate = params.data.textAttendDate
        this.list[i].textAttendEndTime = params.data.textAttendEndTime
        this.list[i].textAttendStartTime = params.data.textAttendStartTime
        this.list[i].userId = params.data.userId
        this.list[i].classTypeText = params.data.classTypeText
        this.list[i].gradesText = params.data.gradesText
        if (i < this.list.length - 1) {
          console.log('i', i)
          this.getInitFile(++i)
        }
      })
    },
    //查看错误
    errInfo(errMsg) {
      this.errorMsgList = errMsg
      this.visibleErr = true
    },
    //确认导入
    confirm() {
      this.visibleWarn = true
      this.isConfirm = true
    },
    confirmErr() {
      this.visibleErr = false
    },
    cancelWarn() {
      this.visibleWarn = false
    },
    // 确认创建
    confirmWarn() {
      this.visibleWarn = false
      this.visibleTips = true
      console.log(' this.batchNumber ', this.batchNumber)
      teacher
        .confirmImport({ batchNumber: this.batchNumber })
        .then((res) => {
          this.successClass = true
        })
        .catch((err) => {
          this.$message.destroy()
          this.errorClass = true
          this.errText = err.msg
        })
    },
    // 重新导入确定按钮
    importWarn() {
      this.visibleWarn = false
      this.list = []
      this.preview()
    },
    // 创建失败
    errorBtn() {
      this.visibleTips = false
      this.errorClass = false
    },
    // 创建成功
    successBtn() {
      this.visibleTips = false
      this.successClass = false
    },
  },
}
</script>

<style lang="scss" scoped>
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.ant-page-header {
  padding: 0;
}
/deep/.ant-modal-header {
  text-align: center;
}
.mr8 {
  margin-right: 8px;
}
.table-top {
  margin-top: 13px;
  border-top: 1px solid rgba(0, 0, 0, 0.6);
  padding-top: 29px;
  padding-bottom: 16px;
  .required {
    color: red;
  }
  .tips {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bfbfbf;
    margin-left: 12px;
  }
  //  选择学期 选择文件
  .semester,
  .file {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    .text {
      color: #333;
      margin-right: 12px;
    }
    .import-excel {
      display: inline-block;
      position: relative;
      display: inline-block;
      .import-btn {
        width: 106px;
        height: 32px;
        cursor: none;
        img {
          width: 16px;
          height: 16px;
        }
      }
      input {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 110px;
        height: 32px;
        z-index: 999;
        opacity: 0;
      }
    }
  }
  // 选择文件
  .file {
    margin-top: 28px;
    .file-name {
      margin-right: 12px;
    }
    .template {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #1890ff;
      margin-left: 12px;
      text-decoration: underline;
    }
  }
  // 导入预览
  .preview {
    margin-top: 27px;
  }
}
.active {
  color: #ff0000;
  cursor: pointer;
}
.error {
  color: #1890ff;
  cursor: pointer;
}
// 表格部分
.table {
  .confirm-btn {
    text-align: center;
    margin-top: 32px;
  }
}
// 查看错误
.confirm-err {
  text-align: center;
  margin-top: 39px;
}
// 确认建班/重新导入
.confirm-warn {
  text-align: center;
  margin-top: 48px;
}
.warning-title {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  img {
    width: 20px;
    height: 20px;
    margin-right: 4px;
  }
}
.warning-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.65);
  margin-top: 12px;
  text-align: center;
}
// 建班成功/建班失败
.tips-title {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(0, 0, 0, 0.85);
  img {
    width: 60px;
    height: 60px;
    margin-bottom: 8px;
  }
  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px;
  }
  .btn {
    margin-top: 35px;
  }
}
.red {
  color: red;
}
</style>
